module.exports = __webpack_public_path__ + "static/media/coreimg3.d727a5f0.png";